module.exports = __webpack_public_path__ + "img/38@2x.2837bfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/38@2x.png
// module id = uwRh
// module chunks = 0